import { useCallback, useState } from "react";
import { useFetch } from "../../../utils/hooks/useFetch";
import { useToastInfo } from "../../../utils/hooks/useToastInfo";
import { fetchTimesheetDetailsByIdReqConfig } from "../../../utils/services/timesheet";
import { mapResponseDataToUi, getWeekRange } from "../../../utils/helpers";
import { startOfWeek, endOfWeek } from "date-fns";
import { TIMESHEET_ACTION_STATES } from "../../../utils/constants";
export const useTimesheetDetails = () => {
  const { isLoading, performAction } = useFetch();
  const { toastInfo, setToastInfo } = useToastInfo();
  const [timesheetInfo, setTimesheetInfo] = useState(null);
  const [week, setWeek] = useState({
    firstDay: startOfWeek(new Date(), { weekStartsOn: 1 }),
    lastDay: endOfWeek(new Date(), { weekStartsOn: 1 }),
  });
  const fetchTimesheetDetails = useCallback(
    async (timesheetId) => {
      try {
        const { url, options } =
          fetchTimesheetDetailsByIdReqConfig(timesheetId);
        const response = await performAction(url, options);
        if (Array.isArray(response?.Result) && response?.Result?.length) {
          const timsheetRange = getWeekRange(response.Result[0].WorkDate);
          const {
            ProjectID,
            ProjectName,
            Comments,
            ApproverComments,
            ManagerName,
            ManagerEmail,
            TimesheetID,
            Status,
            ResourceName,
            RecruiterName,
            ClientName,
            ClientAddress,
            LastApprovedOn,
            LastSubmittedOn,
            POStartDate,
            POEndDate,
            Attachments,
          } = response.Result[0]?.Data[0] || {};
          const timeEntriesData = response.Result.map((res) => {
            return {
              IsHoliday: res.IsHoliday,
              WorkDate: res.WorkDate,
              Details: res.Data,
            };
          });
          const timesheetDetailsInfo = {
            projectId: ProjectID,
            projectName: ProjectName,
            managerName: ManagerName,
            managerEmail: ManagerEmail,
            timesheetId: TimesheetID,
            resourceName: ResourceName,
            hiringManager: RecruiterName || "N/A",
            poStartDate: POStartDate ? POStartDate : "",
            poEndDate: POEndDate ? POEndDate : "",
            attachments: Attachments,
            clientName: ClientName || "N/A",
            workLocation: ClientAddress || "N/A",
            lastApprovedOn: (LastApprovedOn || "").startsWith("0001")
              ? "N/A"
              : LastApprovedOn,
            lastSubmittedOn: (LastSubmittedOn || "").startsWith("0001")
              ? "N/A"
              : LastSubmittedOn,
            timesheetData: mapResponseDataToUi(timeEntriesData),
            comments: Comments,
            approverComments: ApproverComments,
            showCopyButton: !Status || Status === TIMESHEET_ACTION_STATES.DRAFT,
            showApproverActionButton:
              Status === TIMESHEET_ACTION_STATES.SUBMITTED,
            status: Status,
            mode:
              !Status || Status === TIMESHEET_ACTION_STATES.DRAFT
                ? "edit"
                : "read",
            isEditable: Status !== TIMESHEET_ACTION_STATES.APPROVED,
          };

          setTimesheetInfo(timesheetDetailsInfo);
          setWeek(timsheetRange);
          return { timesheetDetailsInfo, timsheetRange };
        }
        throw new Error("Unable to fetch TimesheetDetails");
      } catch (e) {
        console.error("Error fetching timesheet details");
        setToastInfo({
          message: e.message,
          type: "error",
          autoExpire: true,
        });
      }
    },
    [performAction, setToastInfo]
  );
  return {
    isLoading,
    selectedWeek: week,
    toastInfo,
    timesheetInfo,
    setToastInfo,
    fetchTimesheetDetails,
  };
};
